// Author Liang Gangqiang
// Date 2021-04-27 15:13:22

class SithMesQualityInspectTemplateData {
constructor({
        id = null,
        templateRootId = '',
        templateId = '',
        taskId = '',
        value = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.templateRootId = templateRootId;
    this.templateId = templateId;
    this.taskId = taskId;
    this.value = value;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesQualityInspectTemplateData();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'templateRootId',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.grid.templateRootId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'templateId',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.grid.templateId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'taskId',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.grid.taskId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'value',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.grid.value',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    templateRootIdFilter : "",
    templateIdFilter : "",
    taskIdFilter : "",
    valueFilter : "",
    seqFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'templateRootIdFilter',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.filter.templateRootId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'templateIdFilter',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.filter.templateId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'taskIdFilter',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.filter.taskId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'valueFilter',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.filter.value',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'templateRootId',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.entity.templateRootId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'templateId',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.entity.templateId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'taskId',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.entity.taskId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'value',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.entity.value',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTemplateData.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesQualityInspectTemplateData, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
